// src/utils/facilitiesApi.js
//
// AISC 207-25 GR §4.14–4.17 Multi-Site auditing — facilities frontend API client.
// Backend deployed 2026-05-05 (Wave A); routes live but no SPA route until 2026-05-07.
// Mirrors the convention of calibrationApi.js, detailerQualificationsApi.js, etc.

import ApiCall from "./apicall";

export const facilitiesApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return ApiCall.get(`/facilities${qs ? `?${qs}` : ""}`);
  },
  get: (id) => ApiCall.get(`/facilities/${id}`),
  create: (payload) => ApiCall.post("/facilities", payload),
  update: (id, payload) => ApiCall.put(`/facilities/${id}`, payload),
  remove: (id) => ApiCall.delete(`/facilities/${id}`),
};

export default facilitiesApi;
